import React from 'react'
import ReactDOM from 'react-dom/client'
import { Amplify } from 'aws-amplify'
import amplifyconfig from './amplifyconfiguration.js'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import './index.css'

// Configure Amplify with error handling
let configError = null
try {
  console.log('Configuring Amplify...')
  Amplify.configure(amplifyconfig)
  console.log('Amplify configured successfully')
} catch (error) {
  console.error('Error configuring Amplify:', error)
  configError = error
}

// Show configuration error on page if it exists
if (configError) {
  const root = document.getElementById('root')
  root.innerHTML = `
    <div style="padding: 40px; font-family: sans-serif; max-width: 800px; margin: 0 auto;">
      <h1 style="color: #dc2626;">Configuration Error</h1>
      <p>Failed to configure AWS Amplify. This is preventing the app from loading.</p>
      <details style="margin-top: 20px;">
        <summary style="cursor: pointer; font-weight: bold;">Error Details</summary>
        <pre style="background: #f5f5f5; padding: 15px; border-radius: 8px; overflow: auto; margin-top: 10px;">
${configError.message}
${configError.stack}
        </pre>
      </details>
      <p style="margin-top: 20px;">
        <strong>To fix this:</strong>
        <ol>
          <li>Open browser console (F12) and check for more details</li>
          <li>Verify the Amplify configuration is correct</li>
          <li>Check that all API endpoints are accessible</li>
        </ol>
      </p>
      <button 
        onclick="window.location.reload()" 
        style="margin-top: 20px; padding: 12px 24px; background: #5a7a5e; color: white; border: none; border-radius: 8px; cursor: pointer; font-size: 16px;"
      >
        Reload Page
      </button>
    </div>
  `
} else {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  )
}

